import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Breadcrumb from "@/components/base/Breadcrumb";

export default function About() {
  return (
    <SiteLayout
      title="关于我们 - 91动漫"
      description="91动漫是面向动漫爱好者的动漫资讯与作品推荐平台，介绍网站定位、内容范围、更新节奏与联系方式，并说明内容版权与使用规则。"
      keywords="关于91动漫,动漫资讯平台,动漫推荐网站,内容版权说明"
    >
      <section className="w-full bg-foreground-950">
        <div className="w-full px-4 md:px-8 pt-8 md:pt-12 pb-10 md:pb-14">
          <div className="text-background-300">
            <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />
          </div>
          <h1 className="mt-4 font-heading font-bold text-background-50 text-2xl md:text-4xl tracking-tight">
            关于我们
          </h1>
          <p className="mt-3 text-sm md:text-base text-background-300 leading-relaxed max-w-2xl">
            91动漫是一个由动漫爱好者组成的小团队运营的内容门户。我们相信，喜欢一部作品需要一个入口，而这个入口应该足够清晰、足够快。
          </p>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-50">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_340px] gap-8 lg:gap-12">
          <div className="min-w-0">
            <h2 className="font-heading font-bold text-foreground-950 text-lg md:text-xl flex items-center gap-2.5">
              <span className="w-1.5 h-4 rounded-full bg-primary-500" />
              网站简介
            </h2>
            <div className="mt-4 space-y-4 text-sm md:text-base text-foreground-700 leading-[1.95]">
              <p>
                91动漫成立于 2022 年，最初只是几位朋友共享新番观后感的文档。随着内容越来越多，我们把它整理成了一个公开的资讯与作品图鉴站点，希望把「今天有什么新消息」「这部作品值不值得看」这两件事讲清楚。
              </p>
              <p>
                目前站内分为资讯与作品两条主线：资讯频道涵盖新番情报、行业动态、剧场版消息、线下活动与声优动态；作品库则收录日本、中国、美国等地区的动画作品，提供类型标签、简介、主要角色与制作团队信息，并配合编辑推荐与综合评分，方便快速判断。
              </p>
              <p>
                我们不追逐标题党，也不把评分当作绝对标准。所有推荐都来自编辑部的实际观看与讨论，评分仅为参考，欢迎你有自己的判断。
              </p>
            </div>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4">
              {[
                { label: "资讯条数", value: "10+", icon: "ri-newspaper-line" },
                { label: "收录作品", value: "12 部", icon: "ri-book-2-line" },
                { label: "内容更新", value: "每日两次", icon: "ri-time-line" },
              ].map((s) => (
                <div key={s.label} className="p-4 md:p-5 rounded-lg bg-background-100 border border-background-200">
                  <span className="w-9 h-9 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center">
                    <i className={`${s.icon} text-base`} />
                  </span>
                  <p className="mt-3 font-heading font-bold text-foreground-950 text-lg">{s.value}</p>
                  <p className="mt-0.5 text-[11px] text-foreground-500">{s.label}</p>
                </div>
              ))}
            </div>

            <h2 className="mt-10 font-heading font-bold text-foreground-950 text-lg md:text-xl flex items-center gap-2.5">
              <span className="w-1.5 h-4 rounded-full bg-accent-500" />
              内容范围
            </h2>
            <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
              {[
                { title: "新番情报", desc: "每季新作的开播时间、制作阵容与预告解析。" },
                { title: "行业动态", desc: "制作公司、制作委员会与产业层面的观察与消息。" },
                { title: "作品图鉴", desc: "简介、类型标签、主要角色与制作团队信息整理。" },
                { title: "编辑推荐", desc: "按主题整理的片单，帮助缩小选择范围。" },
              ].map((item) => (
                <div key={item.title} className="p-4 rounded-lg bg-background-100 border border-background-200">
                  <h3 className="font-heading font-semibold text-foreground-950 text-sm flex items-center gap-2">
                    <span className="w-4 h-4 flex items-center justify-center text-accent-700">
                      <i className="ri-check-line text-sm" />
                    </span>
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>

            <h2 className="mt-10 font-heading font-bold text-foreground-950 text-lg md:text-xl flex items-center gap-2.5">
              <span className="w-1.5 h-4 rounded-full bg-secondary-500" />
              版权声明与使用说明
            </h2>
            <div className="mt-4 space-y-3 text-sm text-foreground-700 leading-[1.9]">
              <p>
                站内展示的动漫作品名称、角色与相关素材版权均归原作品权利方所有，本站仅用于资讯介绍与作品推荐，不提供在线播放、下载或任何形式的资源分发。
              </p>
              <p>
                站点内出现的评分、热度、角色与制作人员信息为演示数据，可能与实际作品存在差异，仅用于展示页面结构与内容组织方式。
              </p>
              <p>
                如需转载本站原创的资讯文字内容，请注明来源并保留原文链接；如认为站内内容涉及版权问题，欢迎通过下方邮箱联系，我们会在核实后及时处理。
              </p>
            </div>
          </div>

          <aside className="flex flex-col gap-5">
            <div className="rounded-lg bg-foreground-950 p-5 md:p-6">
              <h2 className="font-heading font-semibold text-background-50 text-sm">联系方式</h2>
              <ul className="mt-4 space-y-4">
                <li>
                  <p className="text-[11px] text-background-400 font-label">内容合作 / 版权反馈</p>
                  <a
                    href="mailto:hello@91anime.example"
                    className="mt-1 inline-flex items-center gap-2 text-sm text-background-100 hover:text-primary-400 transition-colors duration-200 cursor-pointer break-all"
                  >
                    <span className="w-4 h-4 flex items-center justify-center shrink-0">
                      <i className="ri-mail-line" />
                    </span>
                    hello@91anime.example
                  </a>
                </li>
                <li>
                  <p className="text-[11px] text-background-400 font-label">读者来信 / 投稿</p>
                  <a
                    href="mailto:story@91anime.example"
                    className="mt-1 inline-flex items-center gap-2 text-sm text-background-100 hover:text-primary-400 transition-colors duration-200 cursor-pointer break-all"
                  >
                    <span className="w-4 h-4 flex items-center justify-center shrink-0">
                      <i className="ri-edit-line" />
                    </span>
                    story@91anime.example
                  </a>
                </li>
                <li>
                  <p className="text-[11px] text-background-400 font-label">内容更新时间</p>
                  <p className="mt-1 text-sm text-background-100">每日 09:00 与 21:00 各更新一次</p>
                </li>
              </ul>
              <div className="mt-5 pt-4 border-t border-background-50/10">
                <p className="text-[11px] text-background-400 leading-relaxed">
                  邮件通常在 2 个工作日内回复，版权类问题会优先处理。
                </p>
              </div>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100 p-5">
              <h2 className="font-heading font-semibold text-foreground-950 text-sm">快速入口</h2>
              <div className="mt-3 flex flex-col gap-2">
                {[
                  { to: "/news", label: "动漫资讯", icon: "ri-newspaper-line" },
                  { to: "/anime", label: "动漫作品", icon: "ri-book-2-line" },
                  { to: "/search", label: "搜索内容", icon: "ri-search-line" },
                  { to: "/", label: "返回首页", icon: "ri-home-4-line" },
                ].map((l) => (
                  <Link
                    key={l.to}
                    to={l.to}
                    className="flex items-center justify-between h-10 px-3 rounded-md bg-background-50 border border-background-200 text-xs md:text-sm text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors duration-200 cursor-pointer"
                  >
                    <span className="flex items-center gap-2">
                      <i className={`${l.icon} text-sm text-primary-600`} />
                      {l.label}
                    </span>
                    <i className="ri-arrow-right-s-line text-foreground-400" />
                  </Link>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100 border-t border-background-200">
        <div className="max-w-3xl">
          <h2 className="font-heading font-bold text-foreground-950 text-lg md:text-xl">团队与致谢</h2>
          <p className="mt-3 text-sm text-foreground-700 leading-[1.9]">
            目前团队由 4 名成员组成：两名内容编辑、一名视觉设计、一名负责站点维护。我们都在下班后做这件事，所以更新节奏不会非常快，但每一条内容都会认真核对。
          </p>
          <p className="mt-3 text-sm text-foreground-700 leading-[1.9]">
            感谢每一位愿意在评论区与我们讨论剧情、指出错误的朋友。你们的留言是这个站点能继续做下去的重要原因。
          </p>
        </div>
      </section>
    </SiteLayout>
  );
}